<template>
    <div class="swiper-container-kb" >
      <swiper :options="swiperOptions">
        <swiper-slide v-for="img,index in imgList" :key="index">
          <img class="swiper-image-kb" :src="img.img"></img>
        </swiper-slide>
        <div class="swiper-button-next" slot="button-next"></div>  
        <div class="swiper-button-prev" slot="button-prev"></div> 
      </swiper>
      <div class="dialog-close" @click="closePreview">
        <i class="iconfont icon-close"></i>
      </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    index:{
      type:Number,
      default:0,
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        initialSlide: this.index,
      },
    };
  },
  methods:{
    closePreview(){
        this.$emit('close')
    }
  }
};
</script>

<style lang="less" scoped>
.swiper-container-kb {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  .dialog-close{
    width: 40px;
    height: 40px;
    right: 10%;
    top: 20px;
    text-align: center;
    line-height: 40px;
    position: absolute;
    cursor: pointer;
    z-index: 10;
    i{
        color:rgb(0,122,255);
        font-size: 30px;
    }
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    text-align: center;
    /deep/.swiper-button-prev{
      left: 20%;
    }
    /deep/.swiper-button-next{
      right: 20%;
    }
  }
  .swiper-image-kb {
    height:auto;
    width: auto;
    max-height: 100%;
    max-width: 100%;
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);  
  }
}
</style>
